export default {
    POST_USER_LOGIN: '/api/v1/user-login',
    POST_USER_OTP: '/api/v1/user-login/mfa',
    POST_USER_QRCODE: '/api/v1/user-login/qrcode',
}